function SLR_DetailsItem(_details_item)
{
	// parent element
	var self = this;
	self.details_item = _details_item;
	self.item = {
		id: undefined,
		element_id: undefined,
		list_order: undefined,
		deleted: false,
		item_type: undefined,
		value: undefined,
		description: undefined,
		tax_exempt: 0,
		base_fee: 0,
		due_fee: 0,
		base_bypass: undefined,
		due_bypass: undefined,
	};

	self.pending = false;	// requête d'enregistrement en cours
	self.dirty = false;		// changement en attente pendant une insertion

	self.save = function()
	{
		// Le type placeholder « NONE » ne s'enregistre jamais.
		if (!self.item.id && (self.item.item_type == undefined || self.item.item_type == 'NONE')) {
			return false;
		}

		// Une seule insertion à la fois : en attendant l'id, marquer à re-sauver.
		if (!self.item.id && self.pending) {
			self.dirty = true;
			return false;
		}

		// gather data
		var request = new FormData(),
		data = {};

		// null bypass
		if (self.item.base_bypass == undefined) {
			self.item.base_bypass = 'NULL';
		}
		if (self.item.due_bypass == undefined) {
			self.item.due_bypass = 'NULL';
		}

		// build request
		request.append("model", "detailsitem");
		request.append("action", "auto");
		request.append("data", JSON.stringify(self.item));

		if (self.item.base_bypass == 'NULL') {
			self.item.base_bypass = undefined;
		}
		if (self.item.due_bypass == 'NULL') {
			self.item.due_bypass = undefined;
		}

		// add request to queue
		self.pending = true;
		$.slr.db.add(request, self.callback);
		return false;
	};

	self.delete = function()
	{
		self.item.deleted = 1;
		self.save();
	};

	self.callback = function(x)
	{
		self.item.id = x.item_id;
		self.pending = false;
		self.details_item.update_id();

		// Changement survenu pendant l'insertion : ré-enregistrer une fois l'id connu.
		if (self.dirty) {
			self.dirty = false;
			self.save();
		}
	};

	self.getBase = function() {
		if (self.item.base_bypass != undefined) {
			return self.item.base_bypass;
		}
		return self.item.base_fee;
	}

	self.getDue = function() {
		if (self.item.due_bypass != undefined) {
			return self.item.due_bypass;
		}
		return self.item.due_fee;
	}

	self.init = function()
	{
		if (self.details_item.find("input[name=details_item_id]").val()){
			self.item.id = parseInt(self.details_item.find("input[name=details_item_id]").val(), 10);
		}
	}();
}

$.fn.DetailsItem = function(detailsList)
{
	var _i = this;
	_i.dl = detailsList;
	_i.model = new SLR_DetailsItem(_i);
	_i.config_name = undefined;
	_i.interface = {
		trash_button : _i.find(".trash-item-button"),
		duplicate_button : _i.find(".duplicate-item-button"),
		details_type_select : _i.find("[name=item_type]"),
		item_value : _i.find("input[name=value]"),
		description : _i.find("textarea[name=description]"),
		cell_received : _i.find(".cell-item-received"),
		cell_due : _i.find(".cell-item-due")
	};

	_i.getItemType = function() {
		return _i.interface.details_type_select.val();
	};

	_i.calc = {
		item_fees: function()
		{
			var config = _i.dl.details_tab.e.getConventionItems(),
			base_fee = _i.calc.base_fee(config),
			owed_fee = _i.calc.owed_fee(base_fee);
			// must update bypass with redevance here
			var bypassed = _i.model.item.base_bypass == undefined ? false : 'bypassed';
			if (bypassed === 'bypassed') {
				var redevance = _i.dl.details_tab.e.el.form.get_redevance()
				_i.find("input[name=due_bypass]").val(_i.model.item.base_bypass * redevance / 100);
				_i.model.item.due_bypass = parseFloat(_i.find("input[name=due_bypass]").val());
			}
			return [base_fee, owed_fee, _i.model.item.base_bypass, _i.model.item.due_bypass, bypassed];
		},
		base_fee: function(config)
		{
			// get base config
			var item_type = _i.interface.details_type_select.val(),
			item_value = _i.interface.item_value.val();
			if (item_type == 0 || item_type == undefined || !config[item_type]){
				return 0;
			}

			// calculate base fee
			var item_config = config[item_type].calc,
			fee = 0;

			// set field values
			switch (item_config[0]) {
				case "float": {
					var raw_value = asFloat(item_value.replace(',', '.'));
					if (!raw_value) raw_value = 0;
					raw_value = raw_value.toLocaleString('fr-CA', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					});
					_i.interface.item_value.val(raw_value);
					break;
				}
				case "int": {
					var raw_value = parseInt(item_value, 10);
					if (!raw_value) raw_value = 0;
					_i.interface.item_value.val(raw_value);
					break;
				}
				case "%": {
					var raw_value = parseInt(item_value, 10);
					if (!raw_value) raw_value = 0;
					_i.interface.item_value.val(raw_value + "%");
					break;
				}
				case "$": {
					var raw_value = asFloat(item_value, 10);
					if (!raw_value) raw_value = 0;
					raw_value = raw_value.toLocaleString('fr-CA', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					});
					_i.interface.item_value.val(raw_value + " $");
				}
				break;
			}

			// get action
			switch(item_config[1]){
				case "fn": {
					fee = _i.calc.fn[item_config[2]](item_type, item_value, item_config);
					break;
				}
				case "*": {
					var input_value = asFloat(item_value);
					if (isNaN(input_value) || input_value == 0){
						fee = 0;
					} else if (item_config[2] == "inm_role_fee"){
						fee = input_value * _i.calc.fn.get_inm_role_fee(item_type);
					} else {
						fee = input_value * item_config[2];
					}
					break;
				}
				case "=": {
					var input_value = asFloat(item_value);
					if (item_config[2] == "inm_role_fee"){
						return _i.calc.fn.get_inm_role_fee(item_type);
					} else if (isNaN(input_value) || input_value == 0){
						fee = 0;
					} else {
						fee = input_value;
					}
					break;
				}
				case "get": {
					if (item_config[2] == "c"){
						fee = _i.dl.details_tab.e.interface.tabs.guarantees.calc.values.cachet();
					} else if (item_config[2] == "j" || item_config[2] == "d"){
						fee = _i.dl.details_tab.e.interface.tabs.guarantees.calc.fn.grid_value(item_config[2]);
					}
					break;
				}
				default: {
					// * with percentage factor
					if (item_config[1].charAt(0) === "*"){
						var percent = asFloat(item_config[1].substr(1)) / 100,
						input_value = asFloat(item_value);
						if (item_config[0] == "int"){
							input_value = Math.floor(input_value);
						}
						if (isNaN(input_value) || input_value == 0){
							fee = 0;
						} else {
							var _g = _i.dl.details_tab.e.interface.tabs.guarantees;
							if (item_config[2] === "c"){
								fee = input_value * _g.calc.values.cachet() * percent;
							} else if (item_config[2] === "hc"){
								fee = input_value * _g.calc.values.taux_horaire() * percent;
							} else if (isNaN(item_config[2])){
								fee = input_value * _g.calc.fn.grid_value(item_config[2]) * percent;
							} else {
								fee = input_value * item_config[2] * percent;
							}
						}
					}
				}
			}

			// return base fee
			return fee;
		},
		owed_fee: function(base_fee)
		{
			// get redevance percent
			var fee = base_fee,
			redevance = _i.dl.details_tab.e.el.form.get_redevance();

			if (redevance == undefined || !redevance || isNaN(redevance)) {
				redevance = 0;
			}

			fee *= redevance/100;

			// return owed fee
			return fee;
		},
		rights: function() {
			var itemType = _i.model.item.item_type,
			config = _i.dl.details_tab.e.getConventionItems()[itemType],
			_g = _i.dl.details_tab.e.interface.tabs.guarantees;
			if (config != undefined && config.droits){
				var itemFees = _i.calc.item_fees();
				var bypassed = itemFees[4] == 'bypassed';
				return _i.calc.item_fees()[bypassed ? 2 : 0] * _g.calc.values.droits_percent();
			}
			return 0;
		},
		fn: {
			// get fee
			calc_c: function(item_type, item_value)
			{
				// base fee
				var nb_annonces = parseInt(_i.dl.details_tab.e.interface.tabs.fee.get_value('nb_annonces'), 10),
				base_fee = _i.dl.details_tab.e.getBaseOrUpgradeFee();
				if (isNaN(nb_annonces) || !nb_annonces){
					nb_annonces = 1;
				}
				return base_fee / nb_annonces;
			},

			// get role hour
			calc_role: function(item_type, item_value, item_config) {
				if (!item_value) {
					item_value = 0
				}
				var input_value = asFloat(item_value),
				_fee = _i.dl.details_tab.e.interface.tabs.fee,
				role_key = _fee.get_value('role')
				if (isNaN(input_value)) {
					input_value = 0
				}
				if (role_key == undefined) {
					return 0
				}
				if (role_key == 'vhcap' || role_key == 'soliste' || role_key == 'duettiste') {
					role_key = 'ap'
				} else if (role_key == 'petit') {
					role_key = 'choriste'
				}
				if (item_config[0] == 'string') {
					input_value = 1
				}
				if (!item_config[3] || !item_config[3][role_key]) {
					return 0
				}
				var hourly = item_config[3][role_key]
				return hourly * input_value
			},

			// get auditon
			calc_audition: function(item_type, item_value, item_config) {
				var input_value = parseInt(item_value, 10)
				if (!input_value) {
					return 0
				}
				return item_config[3][0] + (item_config[3][1] * (input_value - 1))
			},

			// get fee divided by two
			calc_c_div2: function(item_type, item_value)
			{
				return _i.dl.details_tab.e.getBaseOrUpgradeFee() / 2;
			},

      // get fee multiplied by value
			calc_c_multiply: function(item_type, item_value)
			{
				var nb_multiply = parseInt(item_value, 10);
				if (isNaN(nb_multiply) || !nb_multiply){
					nb_multiply = 0;
				}
				return _i.calc.fn.calc_c() * nb_multiply;
			},

			// get majoration
			calc_c_majoration: function(item_type, item_value)
			{
				var input_value = asFloat(item_value);
				if (isNaN(input_value) || input_value == 0){
					return 0;
				}
				return _i.dl.details_tab.e.getBaseOrUpgradeFee() * input_value / 100;
			},

			// get etiquettes plus
			calc_etiquettes_plus: function(item_type, item_value)
			{
				var input_value = asFloat(item_value),
				item_values = _i.dl.details_tab.e.getConventionItems().ETIQUETTES_PLUS.values,
				total = 0;
				if (isNaN(input_value) || input_value == 0){
					return total;
				}
				if (input_value >= 21){
					var h3 = input_value - 20;
					total += h3 * item_values.x21plus;
					input_value -= h3;
				}
				if (input_value >= 11){
					var h2 = input_value - 10;
					total += h2 * item_values.x11a20;
					input_value -= h2;
				}
				total += input_value * item_values.x1a10;
				return total;
			},

			calc_etiquettes_plus_majoree: function(item_type, item_value) {
				var etiquette_plus_total = _i.calc.fn.calc_etiquettes_plus(item_type, item_value),
				total = etiquette_plus_total,
				cond_percent = parseFloat(_i.dl.details_tab.e.interface.tabs.fee.get_value("cond_percent")) / 100
				if (cond_percent) {
					total *= cond_percent
				}
				return total
			},

			// get supplementaire plus
			calc_supp_plus: function(item_type, item_value)
			{
				var input_value = asFloat(item_value),
				total = 0;
				if (isNaN(input_value) || input_value == 0){
					return total;
				}
				total = 112*input_value;
				return total;
			},

			// inm audition
			calc_inm_audition: function(item_type, item_value)
			{
				var _fee = _i.dl.details_tab.e.interface.tabs.fee,
				input_value = asFloat(item_value),
				total = 0;
				if (isNaN(item_value) || item_value < 1){
					return total;
				}
				total = _fee.calc.option(["audition", "hre_1_audition"]);
				item_value -= 1;
				total += _fee.calc.option(["audition", "hre_2_plus"]) * item_value;
				return total;
			},

			// inm audition_rappel
			calc_inm_rappel_audition: function(item_type, item_value)
			{
				var _fee = _i.dl.details_tab.e.interface.tabs.fee,
				input_value = asFloat(item_value),
				total = 0;
				if (isNaN(item_value) || item_value < 1){
					return total;
				}
				total = _fee.calc.option(["audition", "hre_1_rappel"]);
				item_value -= 1;
				total += _fee.calc.option(["audition", "hre_2_plus"]) * item_value;
				return total;
			},

			// inm min 3h deplacement
			calc_inm_deplacement: function(item_type, item_value)
			{
				var _fee = _i.dl.details_tab.e.interface.tabs.fee,
				input_value = Math.ceil(asFloat(item_value)),
				total = 0;
				if (isNaN(item_value) || item_value < 3){
					input_value = 3;	// min 3 heures
				}
				return input_value * _fee.calc.role_fee(item_type);
			},

			// inm broadcast
			calc_inm_broadcast: function(item_type, item_value)
			{
				var _fee = _i.dl.details_tab.e.interface.tabs.fee;
				return _fee.getBroadcast();
			},

			// get inm role fee number
			get_inm_role_fee: function(item_type)
			{
				var _fee = _i.dl.details_tab.e.interface.tabs.fee;
				var role_fee = _fee.calc.role_fee(item_type);
				return role_fee;
			},

			// get guarantee equivalent
			get_guarantee: function(item_type, item_value)
			{
				var guarantee_fee = _i.dl.details_tab.e.interface.tabs.guarantees.getGuaranteeFee(item_type);
				setTimeout(function() {
					_i.dl.updateRights();
				}, 100);
				return guarantee_fee;
			},

			// get versement
			get_versement: function(item_type, item_value)
			{
				item_value = parseInt(item_value, 10);
				if (!item_value || item_value < 1 || isNaN(item_value)) {
					return 0;
				} else if (item_value < 10) {
					item_value = '0' + item_value;
				}
				var guarantee_fee = _i.dl.details_tab.e.interface.tabs.guarantees.getGuaranteeAmount('VERSEMENT_' + item_value);
				return guarantee_fee;
			},

			/* get multiplied contract value */
			get_cx: function(item_type, item_value)
			{
				var input_value = Math.ceil(asFloat(item_value));
				if (isNaN(input_value)){
					input_value = 0;
				}
				return _i.dl.details_tab.e.interface.tabs.guarantees.calc.values.cachet() * input_value;
			},

			/* get divided contract value */
			get_cd: function(item_type, item_value)
			{
				return _i.dl.details_tab.e.interface.tabs.guarantees.calc.values.cachet() * .5;
			},

			/* get negative value */
			negative: function(item_type, item_value)
			{
				var input_value = Math.ceil(asFloat(item_value));
				if (isNaN(input_value)){
					input_value = 0;
				}
				if (input_value < 0){
					return input_value;
				}
				return input_value * -1;
			},

			/* get rights for items */
			get_rights_for_items: function(item_type, item_value)
			{
				return _i.dl.getRights();
			},
		}
	};

	_i.trash = function()
	{
		swal({
			title: "Êtes-vous certain?",
			text: "Voulez-vous vraiment supprimer cet item?",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-danger",
			confirmButtonText: "Oui, supprimer l'item",
			cancelButtonText: "Non",
			closeOnConfirm: true,
			closeOnCancel: true
		},
		function(isConfirm) {
			if (isConfirm) {
				_i.model.delete(); // from db
				_i.slideUp("fast", function(){ // from view
					_i.dl.remove_details_item(_i); // from list
					_i.remove(); // from dom
					_i.dl.details_items_sorted(); // save order
				});
			}
		});
		return false;
	};

	_i.duplicate = function()
	{
		_i.dl.duplicate_details_item(_i); // in list
		return false;
	};

	_i.update_id = function()
	{
		_i.find("input[name=details_item_id]").val(_i.model.item.id);
	};

	_i.save = function()
	{
		_i.model.save();
	};

	_i.set = function(key, value)
	{
		_i.model.item[key] = value;
		_i.save();
	}

	_i.changed = function(event)
	{
		var key = $(event.target).attr("name"),
		value = $(event.target).val();
		if (key == 'tax_exempt') {
			if (!$(event.target).prop('checked')) {
				value = 0;
			}
		}
		_i.updateItemFees();
		_i.dl.updateTotals();
		_i.dl.updateRights();
		_i.set(key, value);
		_i.dl.details_tab.e.updateDetailsSummary();
	};

	_i.update = function()
	{
		_i.dl.details_tab.updateTypesSelect(true);
		_i.updateItemsSelect(true);
		_i.updateItemFees();
		_i.dl.updateTotals();
		_i.dl.details_tab.e.updateDetailsSummary();
	};

	_i.getDetailsTitle = function()
	{
		var title = "";
		if (_i.dl.details_tab.e.el.form.get_invoice_type() == 3) {
			title = _i.interface.description.val();
		} else {
			title = _i.interface.details_type_select.find("option:selected").text();
		}
		return title;
	};

	_i.updateItemFees = function()
	{
		// on load calc fee
		var fees = _i.calc.item_fees();
		var bypassed = fees[4] == 'bypassed';
		var	amount_received = fees[bypassed ? 2 : 0].toLocaleString('fr-CA', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}),
		amount_due = fees[bypassed ? 3 : 1].toLocaleString('fr-CA', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		_i.interface.cell_received.html(amount_received);
		_i.interface.cell_due.html(amount_due);
		_i.model.item.base_fee = fees[0];
		_i.model.item.due_fee = fees[1];
		if (bypassed) {
			_i.interface.cell_received.parent().addClass('bypassed');
		} else {
			_i.interface.cell_received.parent().removeClass('bypassed');
		}
	};

	_i.updateItemsSelect = function(maybe_save)
	{
		// remove select choices
		var previousValue = _i.interface.details_type_select.val();
		_i.config_name = _i.dl.details_tab.e.getConventionName();
		_i.interface.details_type_select.find("option").remove();

		// parse possible new choices
		var parent_name = _i.dl.details_tab.get_value('element_type');
		if (_i.dl.details_tab.e.getConventionTypes()[parent_name] != undefined){
			var child_items = _i.dl.details_tab.e.getConventionTypes()[parent_name].children;
			_i.find(".template-" + _i.config_name + "-detailsitem option").each(function(){
				if (child_items == "ALL" || $(this).val() == "NONE" || child_items.indexOf($(this).val()) !== -1 || !child_items.length){
					_i.interface.details_type_select.append($(this).clone());
				}
			});
		}

		// maybe save if value has to change
		if (maybe_save){
			if (previousValue && previousValue != 0 && previousValue != "NONE" && _i.interface.details_type_select.find("option[value=" + previousValue + "]").length){
				_i.interface.details_type_select.val(previousValue);
			} else {
				_i.interface.details_type_select.val("NONE").change();
			}
		}

		// make sure the model item has the current value
		_i.model.item.item_type = _i.interface.details_type_select.val();
	};

	return function()
	{
		// initialize item and save to db
		if (_i.dl.details_tab.e.getElementID()){
			_i.model.item.element_id = _i.dl.details_tab.e.getElementID();
			_i.model.item.list_order = parseInt(_i.find("input[name=list_order]").val(), 10);
			_i.model.item.item_type = _i.find("select[name=item_type]").val();
			_i.model.item.value = _i.find("input[name=value]").val();
			_i.model.item.tax_exempt = _i.find("input[name=tax_exempt]").prop('checked') ? 1 : 0;
			if (_i.find("input[name=base_bypass]").val()) {
				_i.model.item.base_bypass = parseFloat(_i.find("input[name=base_bypass]").val());
				_i.model.item.due_bypass = parseFloat(_i.find("input[name=due_bypass]").val());
			}
		}

		// change
		_i.on("change", _i.changed);
		_i.interface.trash_button.on("click", _i.trash);
		_i.interface.duplicate_button.on("click", _i.duplicate);
		_i.updateItemsSelect(false);

		// select with search
		_i.find(".element-select-search").each(function(){
			$(this).select2({
				language: "fr"
			}).on("select2:select", function(e){
				_i.interface.item_value.focus().select();
				_i.dl.updateRights();
			});
		});

		// update fees
		_i.updateItemFees();
		_i.dl.updateTotals();

		// cell bypass
		_i.interface.cell_received.BypassCell(_i);

		// return
		return _i;
	}();
};

$.fn.BypassCell = function(_i) {
	var cell = this;
	cell.item = _i;
	cell.bypass_field = cell.siblings('input');

	cell.clicked = function() {
		var bypass_value = prompt('Veuillez entrer le montant de la correction.', cell.bypass_field.val()), bypassed = false;
		if (bypass_value) {
			bypass_value = bypass_value.replace(',', '.');
			bypass_value = parseFloat(bypass_value);
			if (!isNaN(bypass_value) && bypass_value != 0) {
				bypassed = true;
				var redevance = cell.item.dl.details_tab.e.el.form.get_redevance();
				cell.item.set('base_bypass', bypass_value);
				cell.item.set('due_bypass', bypass_value * redevance / 100);
				cell.bypass_field.val(bypass_value);
			}
		}
		if (!bypassed) {
			cell.item.set('base_bypass', undefined);
			cell.item.set('due_bypass', undefined);
			cell.bypass_field.val('');
		}
		cell.item.trigger("change");
	};

	return function() {
		cell.on('click', cell.clicked);
		return cell;
	}();
}
